import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import moment from 'moment';

import MonthlyAvailability from './MonthlyAvailability'

import labels from '../../../configuration/labels'
import { getPricingComment } from '../../../redux/reducers/configuration'
import { onEnter } from '../../../utilities/accessibility/onEnter'
import '../../../styles/scss/elements/mobile-pricing.scss'

const MobilePricing = ({
  onSelectPricingCategory,
  onSetSelectedDate,
  pricingCategories,
  pricing,
  selectedDate,
  selectedPricingCategoryIndex,
}) => {
  const calendarPricingComment = useSelector(getPricingComment)
  const sortedAvailabilityMonths = _.sortBy(_.keys(pricing))
  const months = useMemo(() => {
    const date = moment().startOf('month');
    const months = [date.format('YYYY-MM')];
    while (months.length < 24) {
      months.push(date.add(1, 'month').format('YYYY-MM'))
    }
    return months;
  }, [])
  return (
    <div className="u-full-width u-flex u-flex-column u-flex-align-center mobile-pricing">
      <h2>{labels.selectDate}</h2>
      <p className="pricing-disclaimer">
        * {calendarPricingComment}
      </p>
      {Boolean(_.size(pricingCategories) > 1) && (
        <div className="u-flex u-flex-column mobile-pricing__categories">
          {_.map(pricingCategories, (category, index) => (
            <button
              key={`${category}`}
              className={index === selectedPricingCategoryIndex ? 'mobile-pricing__categories__selected' : ''}
              aria-label={category}
              onClick={() => onSelectPricingCategory(index)}
              onKeyDown={event => onEnter(event, () => onSelectPricingCategory(index))}
            >
              {category}
            </button>
          ))}
        </div>
      )}
      {Boolean(_.size(sortedAvailabilityMonths)) && (
        <ul className="u-full-width mobile-pricing__month-list">
          {_.map(months, (month, index) => (
            <MonthlyAvailability
              key={month}
              availability={_.get(pricing, `[${month}]`)}
              isInitiallyExpanded={month === _.keys(pricing)[0]}
              month={month}
              onSelectDate={onSetSelectedDate}
              selectedDate={selectedDate}
            />
          ))}
        </ul>
      )}
    </div>
  );
}

export default MobilePricing